import { create } from 'zustand'

type DeviceStore = {
    orientationPermission: string
    userInteraction: boolean
    setOrientationPermission: (permission: 'request' | 'nodevice' | 'granted' | 'denied') => void
    checkOrientationPermission: () => void
    setUserInteraction: (interaction: boolean) => void
}
const useDevice = create<DeviceStore>((set, get) => ({
    orientationPermission: null as DeviceStore["orientationPermission"],
    userInteraction: false as DeviceStore["userInteraction"],

    setOrientationPermission: (permission) => {
        set({ orientationPermission: permission })
    },
    checkOrientationPermission: () => {
        // if (DeviceOrientationEvent && typeof (DeviceOrientationEvent as any).requestPermission === 'function') {
        //     set({ orientationPermission: 'request' })
        // }
        // else {
        //     const checkEvent = (e: DeviceOrientationEvent) => {
        //         if (e.alpha !== null && e.beta !== null && e.gamma !== null) {
        //             set({ orientationPermission: 'granted' })
        //             window.removeEventListener('deviceorientation', checkEvent, false)
        //         }
        //         else {
        //             set({ orientationPermission: 'nodevice' })
        //             window.removeEventListener('deviceorientation', checkEvent, false)
        //         }
        //     }
        //     window.addEventListener('deviceorientation', checkEvent, false)
        // }
        const getPermission = () => {
            if (DeviceOrientationEvent && typeof (DeviceOrientationEvent as any).requestPermission === 'function') {
                set({ orientationPermission: 'request' })
            }
            else {
                set({ orientationPermission: 'nodevice' })
            }
        }
        const checkEvent = (e: DeviceOrientationEvent) => {
            if (e.alpha !== null && e.beta !== null && e.gamma !== null) {
                set({ orientationPermission: 'granted' })
                window.removeEventListener('deviceorientation', checkEvent, false)
            }
            else {
                getPermission()
                window.removeEventListener('deviceorientation', checkEvent, false)
            }
        }
        window.addEventListener('deviceorientation', checkEvent, false)

        const checkTimeout = setTimeout(() => {
            if (get().orientationPermission === null) {
                getPermission()
            }
        }, 100)
    },
    setUserInteraction: (interaction) => {
        set({ userInteraction: interaction })
    }
}))

export default useDevice
